import React from 'react';
import Header from '../common/header';
import Side from '../common/side';
import Main from './main';
import Footer from './footer';
import '../../css/createSiteSearch.css';
import axios from "axios";
import {apiURLSiteSearch, apiURLCreateSiteSearch} from '../../utils/constants'

//デザインを未選択の状態
const SEARCH_FORM_DESIGN_NOT_SELECT = 0

class App extends React.Component {

  //コンストラクター
  constructor(props) {
    super(props);

    this.state = {
      step: 1,
      totalstep: 4,
      steptitle: {
          1: "対象ドメインの設定", 
          2: "オプションの設定",
          3: "デザインの設定",
          4: "確認"
      },
      contenttitle: {
        1: "ドメインを入力してください", 
        2: "オプションを選択してください",
        3: "デザインを選択してください",
        4: "設定内容を確認してください"
      },
      keyDownEscFlag: false,
      //対象ドメイン
      searchdomain: "",
      //og:imageの表示有無
      isDispOgImage: false,
      //検索結果の表示件数
      dispSearchNum: 10,
      //検索フォームのタイプ(0:未選択(初期値)、1:検索フォーム、2:検索フォーム+ボタン)
      searchFormDesign: 0,
      //モーダル表示フラグ(true:表示、false:非表示)
      isDispModal: false,
      //モーダルのエラーメッセージ内容
      modalErrorMessage: "",
      //BiNDに対するコールバック
      callback: "",
      //BiNDに対するconfig
      config: "",
      //a
      a: "",
      //t
      t: "",
      //entid
      entId: "",
    };

    console.log("init App's state")
    console.log(this.state)
  }

  //コンポーネントマウント時
  async componentDidMount(){
              
    // bind側のパラメータ取得
    let data = window.location.hash.replace("#/CreateSiteSearch","");
    data = data.slice(1).split('&');

    const query = {};
    for(let i=0; i < data.length; i++){
        let cdata = data[i].split('=');
        query[cdata[0]] = cdata[1];
    }
    console.log(query)

    //空の時にsurlの内容を引き継ぐ
    if(this.state.searchdomain == ''){
      // 入力データ
      //bind側の「サイト設定」で登録してある"サイトURL"を取得
      let surl = decodeURIComponent(query.surl);

      console.log(surl)
      //先頭からhttps://を除く（対象のドメインはhttpsという前提）
      surl = surl.replace('https://','')
      //末尾に/がある場合除く
      surl =surl.replace(/\/$/, '')
      console.log(surl)

      //空文字列にする。
      if(surl == 'undefined'){
        surl = ""
      }

      this.updateSearchDomain(surl)
    }

    let callback = decodeURIComponent(query.callback);
    let config = decodeURIComponent(query.config);
    let a = decodeURIComponent(query.a)
    let t = decodeURIComponent(query.t)
    let entId = decodeURIComponent(query.entId)

    //サイト内検索情報取得
    await this.getSearchInfo(a,t)
    //BiND情報更新
    this.updateBiNDInfo(callback,config,a,t,entId)
  }

  //サイドセクションのステップ+1更新
  async plusStep() {

    //次のステップに行く前にバリデーション処理を行う。
    let　errorMessage = this.validateInput()

    if(errorMessage == ""){

      //「適用」ボタンを押下時
      if(this.state.step == this.state.totalstep){
        await this.updateSearchInfo()

      //「次へ」ボタンを押下時
      }else{
        //nextstepを更新
        this.setState({ step: this.state.step + 1 });
      }

    }else{
      //モーダルを表示
      this.setState({
         isDispModal: true,
         modalErrorMessage: errorMessage
      });
    }

  }

  //サイドセクションのステップ-1更新
  minusStep() {
    this.setState({ step: this.state.step - 1 });
  }

  //二重押し防止
  updateKeyDownEscFlag(bvalue) {
    this.setState({ keyDownEscFlag: bvalue });    
  }

  //対象ドメインの更新
  updateSearchDomain(domain) {
    this.setState({ searchdomain: domain });
  }

  //og:imageのチェックボックスの有無
  updateIsDispOgImage(check) {
    this.setState({ isDispOgImage: check });
  }

  //検索結果の表示件数
  updateDispSearchNum(num) {
    this.setState({ dispSearchNum: num });
  }

  //検索フォームのタイプ
  updateSearchFormDesign(type) {
    this.setState({ searchFormDesign: type });
  }

  //モーダルを閉じる
  closeModal() {
    this.setState({ isDispModal: false });
  }

  //BiND情報更新
  updateBiNDInfo(callback,config,a,t,entId) {
    this.setState({
      callback: callback,
      config: config,
      a: a,
      t: t,
      entId: entId
    });
  }

  //各ステップの入力検証
  validateInput(){

    let errorMessage = ""

    //ステップ１の場合
    if(this.state.step == 1){

      //必須チェック
      if(this.state.searchdomain == ''){
        errorMessage = "ドメインを入力してください。"
        return errorMessage
      }

      //domainチェック(複数ドメイン対応)      
      var res = (this.state.searchdomain).match(/^(([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}(\,)*)+$/);
      //正規表現に合致しない場合
      if(res == null){
        errorMessage = "ドメインの形式が正しくありません。"
        return errorMessage

      //正規表現に合致する場合
      }else{
        //末尾の文字が","で終わってる場合は、形式が正しくない。
        if((this.state.searchdomain).slice(-1) == ','){
          errorMessage = "ドメインの形式が正しくありません。"
          return errorMessage
        }
      }

    //ステップ３の場合
    }else if(this.state.step == 3){

      //必須チェック
      if(this.state.searchFormDesign == SEARCH_FORM_DESIGN_NOT_SELECT){
        console.log("step3の必須チェックエラー")
        errorMessage = "どちらかのデザインを選んでください。"
        return errorMessage
      }
    }

    return errorMessage
  }

  //サイト内検索情報取得
  async getSearchInfo(a,t){

    try {

      const data = {
        a: a,
        t: t
      }
      const strdata = JSON.stringify(data);

      axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
      axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

      //情報を取得
      const res = await axios.post(apiURLSiteSearch,strdata)
      console.log(res)

      //処理が上手くいった場合
      if(res.data.success == true){
        //search_info.domainの文字の長さが0でない場合　※ドメインの中身のみ確認すればOK
        if( 0 != Object.keys(res.data.search_info.domain).length){
          this.setState({
            searchdomain: res.data.search_info.domain,
            isDispOgImage: (res.data.search_info.is_ogimg == 0 ? false  : true),
            dispSearchNum: res.data.search_info.disp_searchnum,
            searchFormDesign: res.data.search_info.formdesign
          });
        }
      }else{
        console.log('server error getSearchInfo')
      }

    }catch(err){
      console.log(err)
    }
  }

    //サイト内検索情報更新
  async updateSearchInfo(){

    try {

      const data = {
        searchdomain: this.state.searchdomain ,
        isDispOgImage: this.state.isDispOgImage,
        dispSearchNum: this.state.dispSearchNum,
        searchFormDesign: this.state.searchFormDesign,
        a: this.state.a,
        t: this.state.t
      }
      const strdata = JSON.stringify(data);

      axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
      axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

      //DBへ登録する。
      const res = await axios.post(apiURLCreateSiteSearch,strdata)
      console.log(res)
      if(res.data.success == true){

        //bindに引継ぎ
        const json = JSON.parse(this.state.config)
        json.isDispOgImage = this.state.isDispOgImage
        json.dispSearchNum = this.state.dispSearchNum
        json.searchFormDesign = this.state.searchFormDesign
        json.a = this.state.a
        json.t = this.state.t
        json.entId = this.state.entId

        //完了
        window.location.href = this.state.callback 
          +'&config=' + encodeURIComponent(JSON.stringify(json))
      }
       
    }catch(err) {
      console.log(err)
    }
  }

  render() {
    return (
      <div>
        <div>{this.state.nextstep}</div>
        <Header />
        <Side 
          step={this.state.step}
          totalstep={this.state.totalstep}
          steptitle={this.state.steptitle}
        />
        <Main
          step={this.state.step}
          contenttitle={this.state.contenttitle}
          searchdomain={this.state.searchdomain}
          isDispOgImage={this.state.isDispOgImage}
          dispSearchNum={this.state.dispSearchNum}
          searchFormDesign={this.state.searchFormDesign}
          isDispModal={this.state.isDispModal}
          modalErrorMessage={this.state.modalErrorMessage}
          updateSearchDomain={(domain) => { this.updateSearchDomain(domain); }}
          updateIsDispOgImage={(check) => { this.updateIsDispOgImage(check); }}
          updateDispSearchNum={(num) => { this.updateDispSearchNum(num); }}
          updateSearchFormDesign={(type) => { this.updateSearchFormDesign(type); }}
          closeModal={() => { this.closeModal(); }}
        />
        <Footer
          step={this.state.step}
          totalstep={this.state.totalstep}
          keyDownEscFlag={this.state.keyDownEscFlag} 
          callback={this.state.callback} 
          plusStep={() => { this.plusStep(); }}
          minusStep={() => { this.minusStep(); }}
          updateKeyDownEscFlag={(bvalue) => { this.updateKeyDownEscFlag(bvalue); }}
        />
      </div>
    );
  }
}

export default App;